import { apiGet } from './api';
import { pic } from './site';

/**
 * The public hotel feed. Separate from the admin helpers in `hotels.js` on purpose —
 * these endpoints return the sell price only, never our cost or margin.
 */

const withImage = (h) => ({
  ...h,
  img: h.imageUrl || pic(`${(h.cityName || h.countryName || 'hotel').toLowerCase()},resort,hotel`, 200 + (h.id % 60)),
});

export const fetchHotels = async (destinationId) => {
  const q = destinationId ? `?destinationId=${destinationId}` : '';
  const list = await apiGet(`/api/hotels/public${q}`);
  return (list || []).map(withImage);
};

export const fetchHotel = async (id) => withImage(await apiGet(`/api/hotels/public/${id}`));

export const money = (n) => (n == null ? '—' : `$${Number(n).toLocaleString('en-US')}`);

/** "5*" is how the supplier writes it; "5-star" is how a customer reads it. */
export const stars = (starCategory) => {
  if (!starCategory) return null;
  const n = parseInt(starCategory, 10);
  return Number.isFinite(n) && n > 0 && n <= 5 ? '★'.repeat(n) : starCategory;
};

/** The one-line summary under a hotel name: who it sleeps and on what board. */
export const occupancyLine = (h) => {
  const bits = [];
  if (h.maxAdults > 0) bits.push(`Sleeps up to ${h.maxAdults} adult${h.maxAdults === 1 ? '' : 's'}`);
  bits.push(h.acceptsChildren ? 'children welcome' : 'adults only');
  if (h.mealPlans?.length) bits.push(h.mealPlans.join(', ').toLowerCase());
  return bits.join(' · ');
};

export const fmtDate = (d) => {
  if (!d) return '';
  try { return new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }); } catch { return ''; }
};
